export * from './appointment-participant.interface';
